import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('certificate-request-tokens', { routeName: 'frontdoorResourceRoute' })
export class FrontdoorToken extends Resource {
    id: string;
    token: string;
    commonName: string;
    name: string;
    selected: boolean;
    organization: string;
    organizationalUnit: string;
    frontdoorId: string;
    validYears: string;
    expiresAt: string;
    contactEmail?: string;
    /** The certificate this token renews in place when redeemed. Absent on a token that mints a new certificate. */
    clientCertificateId?: string;
}

